import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

type SearchCardsProps = {
  forDarkNavbar?: boolean;
};

const SearchCards = ({ forDarkNavbar }: SearchCardsProps) => {
  const [cardSearch, setCardSearch] = useState('');

  const openCard = (newTab: boolean) => {
    if (newTab) {
      window.open(`/card/${cardSearch}`, '_blank');
    } else {
      window.location.href = `/card/${cardSearch}`;
    }
  };

  const canSearch = cardSearch.length > 0;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!canSearch) {
      return;
    }
    const submitter = (e.nativeEvent as SubmitEvent).submitter as HTMLButtonElement | null;
    const newTab = submitter?.dataset.openNewTab === 'true';
    openCard(newTab);
  };

  return (
    <Form
      className="d-flex align-items-center"
      style={{ minWidth: 200, maxWidth: 240, flex: '1 1 200px' }}
      data-bs-theme={forDarkNavbar ? 'dark' : undefined}
      onSubmit={handleSubmit}>
      <InputGroup size="sm" className="flex-nowrap">
        <Form.Control
          placeholder="Card account"
          value={cardSearch}
          id="page-card-account-search"
          onChange={(e) => setCardSearch(e.target.value.replace(/[^0-9]/g, ''))}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.altKey) {
              e.preventDefault();
              if (canSearch) {
                openCard(true);
              }
            }
          }}
        />
        <Button variant="primary" type="submit" disabled={!canSearch} data-open-new-tab="false">
          <i className="fas fa-sm fa-search" />
        </Button>
        <Button variant="primary" type="submit" disabled={!canSearch} data-open-new-tab="true">
          <i className="fas fa-sm fa-search-plus" />
        </Button>
      </InputGroup>
    </Form>
  );
};

export default SearchCards;
